import styles from './PositionDetails.module.css';
import { useLocation } from 'react-router-dom';
import PositionHeader from '../../components/PositionDetails/PositionHeader/PositionHeader';
import TokenInfo from '../../components/PositionDetails/TokenInfo/TokenInfo';
import GraphData from '../../components/PositionDetails/GraphData/GraphData';
import { AiOutlineShareAlt } from 'react-icons/ai';
import Modal from '../../components/misc/modal/Modal';
import { useCallback, useState } from 'react';
import {
  RiCloseFill,
  RiTwitterFill,
  RiFacebookFill,
  RiLinkedinFill,
} from 'react-icons/ri';
import Divider from '../../components/misc/Divider/Divider';
import ContentContainer from '../../components/misc/ContentContainer/ContentContainer';

const PositionDetails = ({ range }) => {
  const location = useLocation();

  const { posDetail, TempAPY } = location.state;
  const [showDetailModal, setShowDetailModal] = useState(false);

  const openModal = useCallback(() => {
    setShowDetailModal(true);
  }, [setShowDetailModal]);

  const closeModal = useCallback(() => {
    setShowDetailModal(false);
  }, [setShowDetailModal]);

  const closeButton = (
    <div className={styles.share_button} onClick={closeModal}>
      <RiCloseFill size={27}  />
    </div>
  );

  const socialMediaLinks = (
    <div className={styles.social_media_links}>
      <RiTwitterFill size={15}  />
      <RiFacebookFill size={15}  />
      <RiLinkedinFill size={15}  />
    </div>
  );
  const ModalContent = (
    <ContentContainer customWidth>
      {closeButton}
      <TokenInfo
        posDetail={posDetail}
        range={range}
        TempAPY={TempAPY}
        shareable
      />
      <Divider />
      <GraphData posDetail={posDetail} />
      {socialMediaLinks}
    </ContentContainer>
  );
  const ModalOrNull = showDetailModal ? (
    <Modal
      onClose={closeModal}
      title='Choose Coin'
      content={ModalContent}
      noHeader
      noBackground
    />
  ) : null;

  const shareButton = (
    <div className={styles.share_button} onClick={openModal}>
      <AiOutlineShareAlt size={25}  />
    </div>
  );

  return (
    <ContentContainer customWidth>
      <PositionHeader />
      <TokenInfo posDetail={posDetail} range={range} TempAPY={TempAPY} />
      <Divider />
      <GraphData posDetail={posDetail} />
      {shareButton}
      {ModalOrNull}
    </ContentContainer>
  );
};

export default PositionDetails;
